import { BrowserRouter } from "react-router-dom";
import Footer from "./components/atoms/Footer";
import Header from "./components/atoms/Header";
import Routes from "./routes";
// @ts-ignore
import { UiSettingsProvider } from "@ask-christee/ui-response";
import { CONTACT_AGENT_ZIP, DOWNLOAD_PDF, SEND_PDF } from "./config";

import "./home.css";
import "./index.css";
import "./style.css";
import "./App.scss";

function App() {
  return (
    <UiSettingsProvider
      apiUrls={{
        sendPdf: SEND_PDF,
        downloadPdf: DOWNLOAD_PDF,
        agentZip: CONTACT_AGENT_ZIP,
      }}
      isPartner={true}
      stage={process.env.REACT_APP_ENGINE_STAGE || ""}
      recaptchaKey="6LeEtPEdAAAAAKFnf6tjSDFEW4YmBNoUEtGBwjax"
      companyId="tcb"
    >
      <BrowserRouter>
        <div style={{ minHeight: "calc(100vh - 399px)" }}>
          <Header />
          <Routes />
        </div>
        <Footer />
      </BrowserRouter>
    </UiSettingsProvider>
  );
}

export default App;
